<template>
  <div class="rs-content-block">
    {{ title }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPartialContentBlock',
  props: {
    title: String,
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

</style>
